import { render, staticRenderFns } from "./ReflectionHeader.vue?vue&type=template&id=47dff6df&scoped=true&"
import script from "./ReflectionHeader.vue?vue&type=script&lang=js&"
export * from "./ReflectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./ReflectionHeader.vue?vue&type=style&index=0&id=47dff6df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dff6df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
